import { View, Text } from "react-native";
import React from "react";
import tw from "twrnc";

const ManagementComponent = () => {
  return (
    <View style={tw.style("flex-1 bg-white p-4")}>
      <Text>ManagementComponent</Text>
    </View>
  );
};

export default ManagementComponent;
